module.exports = __webpack_public_path__ + "img/1.fdef24d9.png";